import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import cn2011 from "./data/cn2011.vue";
import cn2051 from "./data/cn2051.vue";
import cn2061 from "./data/cn2061.vue";
import { getAction } from '@/api/manage';
import pick from 'lodash.pick';
import moment from 'moment/moment';
import { querySiteTree } from '@/api/api';
export default {
  name: 'waterData',
  components: {
    cn2011: cn2011,
    cn2051: cn2051,
    cn2061: cn2061
  },
  data: function data() {
    return {
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 14
      },
      siteTree: [],
      form: this.$form.createForm(this),
      validatorRules: {
        msgStatus: {
          rules: [{
            required: true,
            message: '请选择数据状态!'
          }]
        },
        siteIds: {
          rules: [{
            required: true,
            message: '请选择站点!'
          }]
        },
        cn: {
          rules: [{
            required: true,
            message: '请选择数据类型!'
          }]
        },
        rangeTime: {
          rules: [{
            type: 'array',
            required: true,
            message: '请选择时间!'
          }]
        }
      },
      dateFormat: 'YYYY-MM-DD',
      dateData: {
        startDate: undefined,
        // 维保起始时间
        endDate: undefined // 维保结束时间

      },
      tabsKey: 'cn2011',
      reviewVisible: false,
      reviewType: '1',
      //审核类型  1：单条审核  2：多条审核
      form_fields: ['msgStatus', 'siteIds', 'cn', 'rangeTime'],
      msgParam: {
        msgStatus: '',
        msgId: '',
        siteIds: '',
        rangeTime: '',
        cn: ''
      },
      columns: [{
        title: '操作',
        align: 'center',
        width: '80px',
        code: 'operate',
        // width:150,
        dataIndex: 'operate',
        colName: 'operate',
        scopedSlots: {
          customRender: 'operate'
        },
        fixed: 'left'
      } // , {
      //   title: '状态',
      //   align: 'center',
      //   width: '80px',
      //   code: 'dataStatus',
      //   // width:150,
      //   dataIndex: 'dataStatus',
      //   colName: 'dataStatus',
      //   scopedSlots: { customRender: 'dataStatus' },
      //   fixed: false
      // }
      ]
    };
  },
  props: ['showSiteTree', 'siteId'],
  watch: {},
  created: function created() {},
  methods: {
    getSite: function getSite() {
      var _this = this;

      if (this.siteTree.length > 0) {
        return;
      }

      querySiteTree({
        addrType: 1
      }).then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];

            _this.siteTree.push(temp);
          }
        }
      });
    },
    handleConfirm: function () {
      var _handleConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.form.validateFields( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(err, values) {
                    var formData, res;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (err) {
                              _context.next = 12;
                              break;
                            }

                            formData = Object.assign(_this2.msgParam, values);
                            formData = _.cloneDeep(formData);

                            if (_this2.reviewType == 1) {
                              delete formData.siteIds;
                              delete formData.rangeTime;
                              delete formData.cn;
                            } else {
                              formData['startTime'] = formData.rangeTime[0].format('YYYY-MM-DD HH:mm:ss');
                              formData['endTime'] = formData.rangeTime[1].format('YYYY-MM-DD HH:mm:ss');
                              formData.siteIds = formData.siteIds.join(',');
                              delete formData.rangeTime;
                              delete formData.msgId;
                            }

                            console.log('formData', formData);
                            _context.next = 7;
                            return getAction('/online/cmd/check/check-status', formData);

                          case 7:
                            res = _context.sent;

                            if (res.success) {
                              _this2.$message.success("".concat(res.message));
                            } else {
                              _this2.$message.error("".concat(res.message));
                            }

                            _this2.reviewVisible = !_this2.reviewVisible;

                            _this2.$refs.dataSourceRef.loadData();

                            _this2.msgParam = {
                              msgStatus: '',
                              msgId: '',
                              siteIds: '',
                              rangeTime: '',
                              cn: ''
                            };

                          case 12:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleConfirm() {
        return _handleConfirm.apply(this, arguments);
      }

      return handleConfirm;
    }(),
    onToReview: function onToReview(record) {
      this.getSite();
      console.log('record', this.$refs.dataSourceRef);
      this.reviewType = '1';
      this.reviewVisible = true;
      this.msgParam.msgId = record.attrs.msgId;
      this.msgParam.msgStatus = record.attrs.msgStatus;
      this.handleResetForm('msgStatus');
    },
    onToMultiReview: function onToMultiReview() {
      this.getSite();
      this.reviewType = '2';
      this.reviewVisible = true;
      this.msgParam.msgStatus = '1'; //默认值

      this.handleResetForm('msgStatus', 'siteIds', 'cn', 'rangeTime');
    },
    handleResetForm: function handleResetForm(fieldStr) {
      var _this3 = this;

      this.form.resetFields();
      this.$nextTick(function () {
        _this3.form.setFieldsValue(pick(_this3.msgParam, fieldStr));
      });
    }
  }
};